// extracted by mini-css-extract-plugin
module.exports = {"link":"defaultLink_link__7T2TU","linkText":"defaultLink_linkText__3k2ZI","label":"defaultLink_label__17eFa"};